/**
 * llm 领域的 GameState 分片注册（存档世界书）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { WorldBookSchema, type WorldBook } from './types/worldBook';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    saveWorldBook?: WorldBook;
  }
}

registerGameStateSlice('saveWorldBook', WorldBookSchema.optional(), () => ({
  enabled: true,
  entries: [],
}));
